/** Ad account kinds where providerAccountId should be shown for disambiguation. */
export const ADS_ACCOUNT_KINDS = new Set([
  "facebook_ads_account",
  "google_ads_customer",
  "linkedin_ads_account",
  "tiktok_ads_account",
]);

export function isAdsAccount(accountOrKind) {
  const kind =
    typeof accountOrKind === "string"
      ? accountOrKind
      : accountOrKind?.providerAccountKind;
  return ADS_ACCOUNT_KINDS.has(kind);
}

/** Normalize ad account IDs for display (Meta act_, Google Ads customer ID, etc.). */
export function formatAdsAccountId(providerAccountId, kind) {
  if (providerAccountId == null || providerAccountId === "") return "";
  const raw = String(providerAccountId).trim();

  if (kind === "facebook_ads_account") {
    return raw.startsWith("act_") ? raw : `act_${raw.replace(/^act_?/, "")}`;
  }

  if (kind === "google_ads_customer") {
    const digits = raw.replace(/\D/g, "");
    if (digits.length === 10) {
      return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return raw;
  }

  return raw;
}

/** Returns formatted ad account ID, or null if not an ads account. */
export function getAccountReferenceId(account) {
  if (!account?.providerAccountId || !isAdsAccount(account)) return null;
  return formatAdsAccountId(account.providerAccountId, account.providerAccountKind);
}

export function getAccountDisplayName(account) {
  return account?.displayName || account?.providerAccountId || "Unknown";
}

/** Single-line title including ID for tooltips / exports. */
export function getAccountDisplayTitle(account) {
  const name = getAccountDisplayName(account);
  const refId = getAccountReferenceId(account);
  return refId ? `${name} (${refId})` : name;
}
